export const GET_LOGIN_INFORMATION = '[LOGIN][INFORMATION] fetching information';
export const GET_LOGIN_INFORMATION_SUCCESS = '[LOGIN][INFORMATION] Info succeded';
export const GET_LOGIN_INFORMATION_FAILURE = "[LOGIN][INFORMATION] Info Failed :'(";
export const POST_LOGIN_PENDING = '[LOGIN][REQUEST] Try to Login';
export const POST_LOGIN_SUCCESS = '[LOGIN][REQUEST] Login Succesfull';
export const POST_LOGIN_FAILURE = '[LOGIN][REQUEST] Login Failed';
export const POST_LOGIN_SSO_PENDING = '[LOGIN][SSO] Validating SSO Login';
export const POST_LOGIN_SSO_SUCCESS = '[LOGIN][SSO] Login Succesfull';
export const POST_LOGIN_SSO_FAILURE = '[LOGIN][SSO] Login Failed';
export const CHANGE_ROLE_SELECTION = '[LOGIN][ROLE] Change dual role selection page state';
export const CLEAR_ERRORS = '[LOGIN][REDUCER] Delete Errors';
export const RETURN_TO_LOGIN = '[LOGIN][REDUCER] Go back to login';
export const GOTO_LOGIN = '[REDIRECT] Go to Login';
export const GOTO_LOGIN_SSO = '[REDIRECT] Go to SSO Login';
export const UPDATE_USER_ROLES = '[LOGIN][UPDATE] update user roles';
export const USER_VALIDATE_TOKEN = '[USER][VALIDATE] user token validate pending';
export const USER_VALIDATE_SUCCESS = '[USER][VALIDATE] user validate success';
export const CLEAR_SESSION = '[LOGIN][RESET] clear session';
export const SET_USER_FROM_SESSION = '[LOGIN][SESSION] set user/token from session storage';
export const LOGOUT_SESSION = '[LOGOUT][SESSION] expire token';
/* TO BE REMOVED */
export const VALIDATE_USER_PENDING = '[LOGIN][VALIDATE] pending user validate';
export const VALIDATE_USER_SUCCESS = '[LOGIN][VALIDATE] succress user validate';
export const VALIDATE_USER_FAILURE = '[LOGIN][VALIDATE] falure user validate';
/* TO BE REMOVED */

export const LOGIN_STATUS = {
  FAILURE: 'FAILURE',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
};

const json = {
  GET_LOGIN_INFORMATION,
  GET_LOGIN_INFORMATION_FAILURE,
  GET_LOGIN_INFORMATION_SUCCESS,
  VALIDATE_USER_PENDING,
  VALIDATE_USER_SUCCESS,
  VALIDATE_USER_FAILURE,
};

export default json;
